import {
  MDBAlert,
  MDBBtn,
  MDBCol,
  MDBIcon,
  MDBInput,
  MDBModalFooter,
  MDBRow,
  MDBScrollspy,
  MDBScrollspyLink,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import PopupLoaderNew from "../../../views/popups/PopupLoaderNew";
import { useForm, useFieldArray } from "react-hook-form";
import { getBillingQuoteInfo, getMisc, updateBillingAccInfo } from "../../../apiclients/streamsapi_bridge";
import { formattedNumber } from "../../../views/popups/phonenumbers/AddRemoveNumbers";
import SaveChanges from "../../topviews/saveCancel";
import PopupLoader from "../../../views/popups/PopupLoader";

function BillingAccInfo({
  accInfo,
  physicalAddress,
  mailingAddress,
  principleOfOrg,
  majorityOwner,
  complianceAdminstrator,
  setIsloading,
  reloadBillingData,
}) {
  const [showAddPopup, setShowAddPopup] = useState(false);
  const [showRemovePopup, setShowRemovePopup] = useState(false);
  const [selectedRemoveItem, setSelectedRemoveItem] = useState(null);
  const [showCountryAlert, setShowCountryAlert] = useState(false);
  const [pendingCountryChange, setPendingCountryChange] = useState(null);

  const handleOpenAddPopup = () => {
    resetAddOwner();
    setShowAddPopup(true);
  };

  const handleCountryChange = (section, newValue) => {
    const prevValue = getValues(`${section}.country_code`);
    if (newValue === prevValue) return;

    const fieldsToClear = [
      `${section}.street_address_1`,
      `${section}.street_address_2`,
      `${section}.city`,
      `${section}.zip_Code`,
    ];
    if (section === "Physical_Address") {
      fieldsToClear.push("Account_Info.federal_taxpayer");
    }
    const hasDataToClear = fieldsToClear.some(
      (field) => (getValues(field) ?? "").toString().trim() !== ""
    );

    if (!hasDataToClear) {
      setValue(`${section}.country_code`, newValue, { shouldDirty: true });
      if (section === "Physical_Address") physicalCountryPendingRef.current = true;
      else mailingCountryPendingRef.current = true;
      return;
    }

    setValue(`${section}.country_code`, newValue, { shouldDirty: false });
    setPendingCountryChange({ section, newValue, prevValue });
    setShowCountryAlert(true);
  };

  const handleCountryAlertOk = () => {
    const { section, newValue } = pendingCountryChange;
    setValue(`${section}.country_code`, newValue, { shouldDirty: true });
    setValue(`${section}.street_address_1`, "", { shouldDirty: true });
    setValue(`${section}.street_address_2`, "", { shouldDirty: true });
    setValue(`${section}.city`, "", { shouldDirty: true });
    setValue(`${section}.zip_Code`, "", { shouldDirty: true });
    if (section === "Physical_Address") {
      setValue("Account_Info.federal_taxpayer", "", { shouldDirty: true });
    }
    if (section === "Physical_Address") physicalCountryPendingRef.current = true;
    else mailingCountryPendingRef.current = true;
    setShowCountryAlert(false);
    setPendingCountryChange(null);
  };

  const handleCountryAlertCancel = () => {
    const { section, prevValue } = pendingCountryChange;
    setValue(`${section}.country_code`, prevValue, { shouldDirty: false });
    if (section === "Physical_Address") physicalCountryPendingRef.current = false;
    else mailingCountryPendingRef.current = false;
    setShowCountryAlert(false);
    setPendingCountryChange(null);
  };

  const handleSaveAddOwner = async (data) => {
    setIsloading(true);
    let saverep = await updateBillingAccInfo({ reqid: 185, siteid: siteId, add_Majority_Owners: data });
    let saverepMsg = await saverep.json();
    setTimeout(() => setIsloading(false), 1000);
    if (saverepMsg?.status === "success") {
      setShowAddPopup(false);
      setSuccessMessage(saverepMsg.message);
      resetAddOwner();
      if (reloadBillingData) {
        preserveDirtyOnReloadRef.current = true;
        try {
          await reloadBillingData();
        } catch (error) {
          console.log("Error reloading billing data:", error);
        }
      }
    } else if (saverepMsg?.message?.errors) {
      saverepMsg.message.errors.forEach((err) => {
        const field = err.param_name.split(".").pop();
        setAddOwnerError(field, { type: "server", message: err.message });
      });
    }
  };

  const handleSaveRemoveOwner = async () => {
    if (!selectedRemoveItem) return;
    setIsloading(true);
    let saverep = await updateBillingAccInfo({ reqid: 185, siteid: siteId, remove_Majority_Owners: { id: selectedRemoveItem.id } });
    let saverepMsg = await saverep.json();
    setTimeout(() => setIsloading(false), 1000);
    if (saverepMsg?.status === "success") {
      setShowRemovePopup(false);
      setSelectedRemoveItem(null);
      setSuccessMessage(saverepMsg.message);
      if (reloadBillingData) {
        preserveDirtyOnReloadRef.current = true;
        try {
          await reloadBillingData();
        } catch (error) {
          console.log("Error reloading billing data:", error);
        }
      }
    } else if (saverepMsg?.message?.errors) {
      saverepMsg.message.errors.forEach((err) => {
        setError(err.param_name, { type: "server", message: err.message });
      });
    }
  };

  const section1 = useRef(null);
  const section2 = useRef(null);
  const section3 = useRef(null);
  const section4 = useRef(null);
  const section5 = useRef(null);
  const section6 = useRef(null);

  const containerRef = useRef(null);
  const preserveDirtyOnReloadRef = useRef(false);
  const physicalCountryPendingRef = useRef(false);
  const mailingCountryPendingRef = useRef(false);
  const isWholesaleAcc = JSON.parse(sessionStorage.getItem("admin_session"))?.isWholesaleAcc ?? false;
  const siteId = JSON.parse(sessionStorage.getItem("admin_session"))?.siteid;

  const sessioncompanyName =
    sessionStorage.getItem("admin_session") &&
      JSON.parse(sessionStorage.getItem("admin_session"))?.companyName
      ? JSON.parse(sessionStorage.getItem("admin_session")).companyName
      : "";

  const companyname = sessioncompanyName;

  const [stateList, setStateList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");

  const {
    register,
    control,
    handleSubmit,
    reset,
    watch,
    setValue,
    getValues,
    formState: { errors, dirtyFields, isDirty },
    setError,
  } = useForm({
    defaultValues: {
      Account_Info: {
        federal_taxpayer: "",
        dunn_num: "",
      },
      Physical_Address: {
        location_name: "",
        street_address_1: "",
        street_address_2: "",
        city: "",
        state_code: "",
        country_code: "",
        zip_Code: "",
      },
      Mailing_Address: {
        location_name: "",
        street_address_1: "",
        street_address_2: "",
        city: "",
        state_code: "",
        country_code: "",
        zip_Code: "",
      },
      Key_Principal_of_the_Organization: {
        title: "",
        first_name: "",
        last_name: "",
        phone_number: "",
        email_address: "",
      },
      Majority_Owners: [],
      Compliance_Administrator: {
        title: "",
        first_name: "",
        last_name: "",
        phone_number: "",
        email_address: "",
      },
    },
  });

  const {
    register: registerAddOwner,
    handleSubmit: handleSubmitAddOwner,
    formState: { errors: addOwnerErrors },
    setError: setAddOwnerError,
    reset: resetAddOwner,
  } = useForm({
    defaultValues: {
      title: "",
      first_name: "",
      last_name: "",
      phone_number: "",
      email_address: "",
      Percent_Ownership: "",
    },
  });

  const { fields: majorityFields } = useFieldArray({
    control,
    name: "Majority_Owners",
    keyName: "rhfId",
  });

  // Existing scrollspy effect
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const scrollspyLinks = document.querySelectorAll(".nav-link");
      const lastLink = scrollspyLinks[scrollspyLinks.length - 1];
      const stickyParent = lastLink.closest(".sticky-top");
      if (stickyParent && lastLink.classList.contains("active")) {
        lastLink.classList.remove("active");
        for (let i = 0; i < scrollspyLinks.length; i++) {
          const firstLink = scrollspyLinks[i];
          const parent = firstLink.closest(".sticky-top");
          if (parent) {
            firstLink.classList.add("active");
            break;
          }
        }
      }
    }, 100);
    return () => clearTimeout(timeoutId);
  }, []);

  // Existing scroll-to-top effect
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  }, []);

  // Load misc (state/country lists)
  useEffect(() => {
    loadMiscData();
  }, []);

  // Sync form from props when billing data arrives
  useEffect(() => {
    const phys = physicalAddress && Object.keys(physicalAddress).length > 0 ? physicalAddress : null;
    const mail = mailingAddress && Object.keys(mailingAddress).length > 0 ? mailingAddress : null;
    const principal = principleOfOrg?.[0] ?? null;
    const compliance = complianceAdminstrator?.[0] ?? null;

    if (phys || mail || principal || compliance || majorityOwner?.length > 0 || accInfo) {
      const keepDirty = preserveDirtyOnReloadRef.current;
      preserveDirtyOnReloadRef.current = false;
      reset({
        Account_Info: {
          federal_taxpayer: accInfo?.federal_taxpayer ?? "",
          dunn_num: accInfo?.dunn_num ?? "",
        },
        Physical_Address: {
          location_name: phys?.location_name ?? "",
          street_address_1: phys?.street_address_1 ?? "",
          street_address_2: phys?.street_address_2 ?? "",
          city: phys?.city ?? "",
          state_code: phys?.state_code ?? "",
          // country_code: "",
          country_code: physicalCountryPendingRef.current ? getValues("Physical_Address.country_code") : "",
          zip_Code: phys?.zip_Code ?? "",
        },
        Mailing_Address: {
          location_name: mail?.location_name ?? "",
          street_address_1: mail?.street_address_1 ?? "",
          street_address_2: mail?.street_address_2 ?? "",
          city: mail?.city ?? "",
          state_code: mail?.state_code ?? "",
          // country_code: "",
          country_code: mailingCountryPendingRef.current ? getValues("Mailing_Address.country_code") : "",
          zip_Code: mail?.zip_Code ?? "",
        },
        Key_Principal_of_the_Organization: {
          title: principal?.title ?? "",
          first_name: principal?.first_name ?? "",
          last_name: principal?.last_name ?? "",
          phone_number: principal?.phone_number ?? "",
          email_address: principal?.email_address ?? "",
        },
        Majority_Owners: (majorityOwner ?? []).map((o) => ({
          id: o.id,
          title: o.title ?? "",
          first_name: o.first_name ?? "",
          last_name: o.last_name ?? "",
          phone_number: o.phone_number ?? "",
          email_address: o.email_address ?? "",
          Percent_Ownership: o.Percent_Ownership ?? "",
        })),
        Compliance_Administrator: {
          title: compliance?.title ?? "",
          first_name: compliance?.first_name ?? "",
          last_name: compliance?.last_name ?? "",
          phone_number: compliance?.phone_number ?? "",
          email_address: compliance?.email_address ?? "",
        },
      }, keepDirty ? { keepDirtyValues: true } : undefined);
    }
  }, [physicalAddress, mailingAddress, principleOfOrg, majorityOwner, complianceAdminstrator, accInfo]);

  // Set country_code (cscode string) after misc loads, using display name from GET response
  useEffect(() => {
    if (countryList.length > 0) {
      // if (physicalAddress?.country && !dirtyFields?.Physical_Address?.country_code) {
      if (physicalAddress?.country && !physicalCountryPendingRef.current) {
        const ccode = countryList.find((c) => c.cname === physicalAddress.country)?.ccode ?? "";
        setValue("Physical_Address.country_code", ccode, { shouldDirty: false });
      }
      // if (mailingAddress?.country && !dirtyFields?.Mailing_Address?.country_code) {
      if (mailingAddress?.country && !mailingCountryPendingRef.current) {
        const ccode = countryList.find((c) => c.cname === mailingAddress.country)?.ccode ?? "";
        setValue("Mailing_Address.country_code", ccode, { shouldDirty: false });
      }
    }
  }, [countryList, physicalAddress, mailingAddress]);

  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage("");
      }, 5000);
    }
  }, [successMessage]);

  async function loadMiscData() {
    try {
      const response = await getMisc(siteId, { misc: ["billing_settings_info"] });
      if (!response.ok) return;
      const data = await response.json();
      setStateList(data?.misc?.billing_settings_info?.state_list ?? []);
      setCountryList(data?.misc?.billing_settings_info?.country_list ?? []);
    } catch (error) {
      console.log("Error loading misc data:", error);
    }
  }

  const handleQuoteClick = async (e, quote) => {
    e.preventDefault();
    try {
      let apiResponse = await getBillingQuoteInfo(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        quote
      );
      console.log("apiResponse ::::::::::::::: ", apiResponse);
      if (apiResponse.status == 200) {
        const blob = await apiResponse.blob();
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");
      }
    } catch (error) {
      console.log("Error ::::::::: " + error);
    }
  };

  function prepareFinalJson(dirty, data) {
    const result = {};
    for (const key of Object.keys(dirty)) {
      if (!dirty[key] || !(key in data)) continue;
      if (key === "Majority_Owners") {
        const modifiedOwners = [];
        (dirty[key] || []).forEach((dirtyRow, i) => {
          if (!dirtyRow || typeof dirtyRow !== "object") return;
          const dirtyKeys = Object.keys(dirtyRow).filter((k) => dirtyRow[k]);
          if (dirtyKeys.length === 0) return;
          const owner = { id: data[key][i].id };
          dirtyKeys.forEach((k) => { owner[k] = data[key][i][k]; });
          modifiedOwners.push(owner);
        });
        if (modifiedOwners.length > 0) result[key] = modifiedOwners;
      } else if (typeof dirty[key] === "object" && !Array.isArray(dirty[key])) {
        const sub = {};
        for (const subKey of Object.keys(dirty[key])) {
          if (dirty[key][subKey]) sub[subKey] = data[key]?.[subKey];
        }
        if (Object.keys(sub).length > 0) result[key] = sub;
      } else {
        result[key] = data[key];
      }
    }
    return result;
  }

  const closeSave = () => {
    reset();
    physicalCountryPendingRef.current = false;
    mailingCountryPendingRef.current = false;
    if (countryList.length > 0) {
      if (physicalAddress?.country) {
        const ccode = countryList.find((c) => c.cname === physicalAddress.country)?.ccode ?? "";
        setValue("Physical_Address.country_code", ccode, { shouldDirty: false });
      }
      if (mailingAddress?.country) {
        const ccode = countryList.find((c) => c.cname === mailingAddress.country)?.ccode ?? "";
        setValue("Mailing_Address.country_code", ccode, { shouldDirty: false });
      }
    }
  };

  const onSubmit = async (data) => {
    const modifiedData = prepareFinalJson(dirtyFields, data);
    if (!modifiedData || Object.keys(modifiedData).length === 0) return;

    modifiedData.reqid = 185;
    modifiedData.siteid = siteId;

    setIsloading(true);
    let saverep = await updateBillingAccInfo(modifiedData);
    let saverepMsg = await saverep.json();
    setTimeout(() => setIsloading(false), 1000);

    if (saverepMsg?.status === "success") {
      setSuccessMessage(saverepMsg.message);
      physicalCountryPendingRef.current = false;
      mailingCountryPendingRef.current = false;
      if (reloadBillingData) {
        try {
          await reloadBillingData();
        } catch (error) {
          console.log("Error reloading billing data:", error);
          reset(data);
        }
      } else {
        reset(data);
      }
    } else {
      if (saverepMsg?.message?.errors) {
        saverepMsg.message.errors.forEach((err) => {
          if (err.param_name.startsWith("Majority_Owners.") && err.position !== undefined) {
            const field = err.param_name.split(".").pop();
            const sentOwner = modifiedData.Majority_Owners?.[err.position];
            const actualIndex = majorityFields.findIndex((f) => f.id === sentOwner?.id);
            if (actualIndex !== -1) {
              setError(`Majority_Owners.${actualIndex}.${field}`, { type: "server", message: err.message });
            }
          } else {
            setError(err.param_name, { type: "server", message: err.message });
          }
        });
      }
    }
  };

  const isSave = Object.keys(dirtyFields).length > 0;

  return (
    <>
      {accInfo && Object.entries(accInfo).length > 0 && (
        <div className="card-body px-0">
          {/* <h5>Account Information</h5> */}
          {/* Hide the Name , Email,Phone,Time Zone according to Jerome's Enhancements suggested changes */}
          {/* <div className="w-100">
          <div className="add-numbermain">
            <label>Name</label>
            <span>{accInfo?.name ?? ""}</span>
          </div>
          <div className="add-numbermain">
            <label>Email</label>
            <span>{accInfo?.email ?? ""}</span>
          </div>
          <div className="add-numbermain">
            <label>Phone</label>
            <span>{accInfo?.phone ?? ""}</span>
          </div>
          <div className="add-numbermain">
            <label>Time Zone</label>
            <span>{accInfo?.time_zone ?? ""}</span>
          </div>
        </div> */}

          <MDBRow>
            <MDBCol
              size="2"
              md="2"
              lg="2"
              sm="12"
              className="col-sm-100 pr-0 leftTabs"
            >
              <MDBScrollspy container={containerRef}>
                <MDBScrollspyLink targetRef={section1}>
                  Account Information
                </MDBScrollspyLink>
                {physicalAddress &&
                  Object.entries(physicalAddress).length > 0 && (
                    <MDBScrollspyLink targetRef={section2}>
                      Physical Address
                    </MDBScrollspyLink>
                  )}
                {mailingAddress &&
                  Object.entries(mailingAddress).length > 0 && (
                    <MDBScrollspyLink targetRef={section3}>
                      Mailing Address
                    </MDBScrollspyLink>
                  )}
                {principleOfOrg && principleOfOrg.length > 0 && (
                  <MDBScrollspyLink targetRef={section4}>
                    Key Principal of the Organization
                  </MDBScrollspyLink>
                )}
                {majorityFields.length > 0 && (
                  <MDBScrollspyLink targetRef={section5}>
                    Majority Owners
                  </MDBScrollspyLink>
                )}
                {complianceAdminstrator &&
                  complianceAdminstrator.length > 0 && (
                    <MDBScrollspyLink targetRef={section6}>
                      Compliance Administrator
                    </MDBScrollspyLink>
                  )}
              </MDBScrollspy>
            </MDBCol>

            <MDBCol
              size="12"
              md="10"
              sm="12"
              pr-0
              className="col-sm-100 pr-0 leftTabContent"
            >
              <div className="vtabHeight pr-5">
                <div ref={containerRef} className="scrollspy-example">
                  {/* ── Section 1: Account Information (read-only) ── */}
                  <section ref={section1} id="section-1" className="cursor-normal">
                    <div className="general-settings">Account Information</div>
 
                      <div className="add-numbermain">
                        <label>Company Name</label>
                        <span>{companyname ?? ""}</span>
                      </div>
                      <div className="add-numbermain">
                        <label>Account ID</label>
                        <span>{accInfo?.account_id ?? ""}</span>
                      </div>
                      <div className="add-numbermain">
                        <label>Name</label>
                        <span>{accInfo?.name ?? ""}</span>
                      </div>
                      <div className="add-numbermain">
                        <label>Current Address Location</label>
                        <span>{accInfo?.address ?? ""}</span>
                      </div>
                      <div className="add-numbermain">
                        <label>Zip</label>
                        <span>{accInfo?.zip ?? ""}</span>
                      </div>
                      <div className="add-numbermain">
                        <label>Phone</label>
                        <span>{formattedNumber(accInfo?.phone) ?? ""}</span>
                      </div>
                      <div className="add-numbermain">
                        <label>Email</label>
                        <span>{accInfo?.email ?? ""}</span>
                      </div>
                      <div className="add-numbermain">
                        <label>Provisioning Date</label>
                        <span>{accInfo?.provisioning_date ?? ""}</span>
                      </div>
                      <div className="add-numbermain">
                        <label>Production Date</label>
                        <span>{accInfo?.production_date ?? ""}</span>
                      </div>
                      {!isWholesaleAcc && (
                        <>
                          <div className="add-numbermain">
                            <label>Contract Term</label>
                            <span>{accInfo?.contract_term ?? ""}</span>
                          </div>
                          <div className="add-numbermain">
                            <label>Contract End Date</label>
                            <span>{accInfo?.contract_end_date ?? ""}</span>
                          </div>
                        </>
                      )} 
                    <div className="add-numbermain">
                      <label>Quote ID</label>
                      <div>
                        {(accInfo?.quote_id ?? "")
                          .split(",")
                          ?.map((quote, index, arr) => (
                            <span key={index}>
                              <a
                                className="h6 text-decoration-underline"
                                onClick={(e) => handleQuoteClick(e, quote)}
                              >
                                {quote ?? ""}
                              </a>
                              {index !== arr.length - 1 && ", "}
                            </span>
                          ))}
                      </div>
                    </div>
       
                      <div className="add-numbermain">
                        <label>Time Zone</label>
                        <span>{accInfo?.time_zone ?? ""}</span>
                      </div> 
                    <div className="add-numbermain">
                      <label>Federal Taxpayer ID/SSN/Business Number <span className="text-danger">*</span></label>
                      <div className="w-30">
                        <MDBInput
                          type="text"
                          className="w-100"
                          maxLength={watch("Physical_Address.country_code") === "CA" ? 25 : 11}
                          {...register("Account_Info.federal_taxpayer", { required: "Federal Taxpayer ID/SSN/Business Number is required." })}
                        />
                        {errors?.Account_Info?.federal_taxpayer && (
                          <p className="text-danger text-small text-wrap-break">{errors.Account_Info.federal_taxpayer.message}</p>
                        )}
                      </div>
                    </div>
                    <div className="add-numbermain">
                      <label>Dun and Bradstreet (D-U-N-S Number)</label>
                      <div className="w-30">
                        <MDBInput
                          type="text"
                          className="w-100"
                          maxLength={11}
                          {...register("Account_Info.dunn_num")}
                        />
                        {errors?.Account_Info?.dunn_num && (
                          <p className="text-danger text-small text-wrap-break">{errors.Account_Info.dunn_num.message}</p>
                        )}
                      </div>
                    </div>
                    {/* Hide the ZIP & Current Address Location according to Jerome's Enhancements suggested changes */}

                    {/* <div className="add-numbermain">
            <label>ZIP</label>
            <span>{accInfo?.zip ?? ""}</span>
          </div>
          <div className="add-numbermain">
            <label>Current Address Location</label>
            <span>
            {accInfo?.address ?? ""}
            </span>
          </div> */}
                  </section>

                  {/* ── Section 2: Physical Address ── */}
                  {physicalAddress &&
                    Object.entries(physicalAddress).length > 0 && (
                      <>
                        <div className="routing-border"></div>
                        <section ref={section2} id="section-2">
                          <div className="general-settings">Physical Address</div>

                          <div className="add-numbermain">
                            <label>Location Name <span className="text-danger">*</span></label>
                            <div className="w-30">
                              <MDBInput
                                type="text"
                                className="w-100"
                                maxLength={30}
                                {...register("Physical_Address.location_name", { required: "Location Name is required" })}
                              />
                              {errors?.Physical_Address?.location_name && (
                                <p className="text-danger text-small text-wrap-break">{errors.Physical_Address.location_name.message}</p>
                              )}
                            </div>
                          </div>

                          <div className="add-numbermain">
                            <label>Street Address 1 <span className="text-danger">*</span></label>
                            <div className="w-30">
                              <MDBInput
                                type="text"
                                className="w-100"
                                maxLength={50}
                                {...register("Physical_Address.street_address_1", { required: "Street Address 1 is required" })}
                              />
                              {errors?.Physical_Address?.street_address_1 && (
                                <p className="text-danger text-small text-wrap-break">{errors.Physical_Address.street_address_1.message}</p>
                              )}
                            </div>
                          </div>

                          <div className="add-numbermain">
                            <label>Street Address 2</label>
                            <div className="w-30">
                              <MDBInput
                                type="text"
                                className="w-100"
                                maxLength={50}
                                {...register("Physical_Address.street_address_2")}
                              />
                              {errors?.Physical_Address?.street_address_2 && (
                                <p className="text-danger text-small text-wrap-break">{errors.Physical_Address.street_address_2.message}</p>
                              )}
                            </div>
                          </div>

                          <div className="add-numbermain">
                            <label>City <span className="text-danger">*</span></label>
                            <div className="w-30">
                              <MDBInput
                                type="text"
                                className="w-100"
                                maxLength={30}
                                {...register("Physical_Address.city", { required: "City is required" })}
                              />
                              {errors?.Physical_Address?.city && (
                                <p className="text-danger text-small text-wrap-break">{errors.Physical_Address.city.message}</p>
                              )}
                            </div>
                          </div>

                          <div className="add-numbermain">
                            <label>State/Province <span className="text-danger">*</span></label>
                            <div className="w-30">
                              <select
                                className="form-select form-control w-100"
                                value={watch("Physical_Address.state_code") ?? ""}
                                onChange={(e) =>
                                  setValue("Physical_Address.state_code", parseInt(e.target.value), { shouldDirty: true })
                                }
                              >
                                {stateList.map((s) => (
                                  <option key={s.sid} value={parseInt(s.sid)}>
                                    {s.sname}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          <div className="add-numbermain">
                            <label>Country <span className="text-danger">*</span></label>
                            <div className="w-30">
                              <select
                                className="form-select form-control w-100"
                                value={watch("Physical_Address.country_code") ?? ""}
                                onChange={(e) => handleCountryChange("Physical_Address", e.target.value)}
                              >
                                {countryList.map((c) => (
                                  <option key={c.ccode} value={c.ccode}>
                                    {c.cname}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          <div className="add-numbermain">
                            <label>ZIP Code <span className="text-danger">*</span></label>
                            <div className="w-30">
                              <MDBInput
                                type="text"
                                className="w-100"
                                maxLength={10}
                                {...register("Physical_Address.zip_Code", { required: "ZIP Code is required" })}
                              />
                              {errors?.Physical_Address?.zip_Code && (
                                <p className="text-danger text-small text-wrap-break">{errors.Physical_Address.zip_Code.message}</p>
                              )}
                            </div>
                          </div>
                        </section>
                      </>
                    )}

                  {/* ── Section 3: Mailing Address ── */}
                  {mailingAddress &&
                    Object.entries(mailingAddress).length > 0 && (
                      <>
                        <div className="routing-border"></div>
                        <section ref={section3} id="section-3">
                          <div className="general-settings">Mailing Address</div>

                          <div className="add-numbermain">
                            <label>Location Name <span className="text-danger">*</span></label>
                            <div className="w-30">
                              <MDBInput
                                type="text"
                                className="w-100"
                                maxLength={50}
                                {...register("Mailing_Address.location_name", { required: "Location Name is required" })}
                              />
                              {errors?.Mailing_Address?.location_name && (
                                <p className="text-danger text-small text-wrap-break">{errors.Mailing_Address.location_name.message}</p>
                              )}
                            </div>
                          </div>

                          <div className="add-numbermain">
                            <label>Street Address 1 <span className="text-danger">*</span></label>
                            <div className="w-30">
                              <MDBInput
                                type="text"
                                className="w-100"
                                maxLength={50}
                                {...register("Mailing_Address.street_address_1", { required: "Street Address 1 is required" })}
                              />
                              {errors?.Mailing_Address?.street_address_1 && (
                                <p className="text-danger text-small text-wrap-break">{errors.Mailing_Address.street_address_1.message}</p>
                              )}
                            </div>
                          </div>

                          <div className="add-numbermain">
                            <label>Street Address 2</label>
                            <div className="w-30">
                              <MDBInput
                                type="text"
                                className="w-100"
                                maxLength={50}
                                {...register("Mailing_Address.street_address_2")}
                              />
                              {errors?.Mailing_Address?.street_address_2 && (
                                <p className="text-danger text-small text-wrap-break">{errors.Mailing_Address.street_address_2.message}</p>
                              )}
                            </div>
                          </div>

                          <div className="add-numbermain">
                            <label>City <span className="text-danger">*</span></label>
                            <div className="w-30">
                              <MDBInput
                                type="text"
                                className="w-100"
                                maxLength={30}
                                {...register("Mailing_Address.city", { required: "City is required" })}
                              />
                              {errors?.Mailing_Address?.city && (
                                <p className="text-danger text-small text-wrap-break">{errors.Mailing_Address.city.message}</p>
                              )}
                            </div>
                          </div>

                          <div className="add-numbermain">
                            <label>State/Province <span className="text-danger">*</span></label>
                            <div className="w-30">
                              <select
                                className="form-select form-control w-100"
                                value={watch("Mailing_Address.state_code") ?? ""}
                                onChange={(e) =>
                                  setValue("Mailing_Address.state_code", parseInt(e.target.value), { shouldDirty: true })
                                }
                              >
                                {stateList.map((s) => (
                                  <option key={s.sid} value={parseInt(s.sid)}>
                                    {s.sname}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          <div className="add-numbermain">
                            <label>Country <span className="text-danger">*</span></label>
                            <div className="w-30">
                              <select
                                className="form-select form-control w-100"
                                value={watch("Mailing_Address.country_code") ?? ""}
                                onChange={(e) => handleCountryChange("Mailing_Address", e.target.value)}
                              >
                                {countryList.map((c) => (
                                  <option key={c.ccode} value={c.ccode}>
                                    {c.cname}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          <div className="add-numbermain">
                            <label>ZIP Code <span className="text-danger">*</span></label>
                            <div className="w-30">
                              <MDBInput
                                type="text"
                                className="w-100"
                                maxLength={10}
                                {...register("Mailing_Address.zip_Code", { required: "ZIP Code is required" })}
                              />
                              {errors?.Mailing_Address?.zip_Code && (
                                <p className="text-danger text-small text-wrap-break">{errors.Mailing_Address.zip_Code.message}</p>
                              )}
                            </div>
                          </div>
                        </section>
                      </>
                    )}

                  {/* ── Section 4: Key Principal of the Organization ── */}
                  {principleOfOrg && principleOfOrg.length > 0 && (
                    <>
                      <div className="routing-border"></div>
                      <section ref={section4} id="section-4">
                        <div className="general-settings">
                          Key Principal of the Organization
                        </div>

                        <div style={{ paddingLeft: "10px" }}>
                          <MDBTable>
                            <MDBTableHead>
                              <tr>
                                <th scope="col">Title <span className="text-danger">*</span></th>
                                <th scope="col">First Name <span className="text-danger">*</span></th>
                                <th scope="col">Last Name <span className="text-danger">*</span></th>
                                <th scope="col">Phone Number <span className="text-danger">*</span></th>
                                <th scope="col">Email Address <span className="text-danger">*</span></th>
                              </tr>
                            </MDBTableHead>
                            <MDBTableBody>
                              <tr className="inputbox-align">
                                <td >
                                  <MDBInput
                                    type="text"
                                    className="w-100"
                                    maxLength={50}
                                    {...register("Key_Principal_of_the_Organization.title", { required: "Title is required" })}
                                  />
                                  {errors?.Key_Principal_of_the_Organization?.title && (
                                    <p className="text-danger text-small text-wrap-break">{errors.Key_Principal_of_the_Organization.title.message}</p>
                                  )}
                                </td>
                                <td >
                                  <MDBInput
                                    type="text"
                                    className="w-100"
                                    maxLength={30}
                                    {...register("Key_Principal_of_the_Organization.first_name", { required: "First Name is required" })}
                                  />
                                  {errors?.Key_Principal_of_the_Organization?.first_name && (
                                    <p className="text-danger text-small text-wrap-break">{errors.Key_Principal_of_the_Organization.first_name.message}</p>
                                  )}
                                </td>
                                <td >
                                  <MDBInput
                                    type="text"
                                    className="w-100"
                                    maxLength={30}
                                    {...register("Key_Principal_of_the_Organization.last_name", { required: "Last Name is required" })}
                                  />
                                  {errors?.Key_Principal_of_the_Organization?.last_name && (
                                    <p className="text-danger text-small text-wrap-break">{errors.Key_Principal_of_the_Organization.last_name.message}</p>
                                  )}
                                </td>
                                <td >
                                  <MDBInput
                                    type="text"
                                    className="w-100"
                                    maxLength={11}
                                    onKeyPress={(event) => {
                                      if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                    {...register("Key_Principal_of_the_Organization.phone_number", { required: "Phone Number is required" })}
                                  />
                                  {errors?.Key_Principal_of_the_Organization?.phone_number && (
                                    <p className="text-danger text-small text-wrap-break">{errors.Key_Principal_of_the_Organization.phone_number.message}</p>
                                  )}
                                </td>
                                <td >
                                  <MDBInput
                                    type="text"
                                    className="w-100"
                                    maxLength={50}
                                    {...register("Key_Principal_of_the_Organization.email_address", { required: "Email Address is required" })}
                                  />
                                  {errors?.Key_Principal_of_the_Organization?.email_address && (
                                    <p className="text-danger text-small text-wrap-break">{errors.Key_Principal_of_the_Organization.email_address.message}</p>
                                  )}
                                </td>
                              </tr>
                            </MDBTableBody>
                          </MDBTable>
                        </div>
                      </section>
                    </>
                  )}

                  {/* ── Section 5: Majority Owners ── */}
                  {majorityFields.length > 0 && (
                    <>
                      <div className="routing-border"></div>
                      <section ref={section5} id="section-5">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="general-settings">Majority Owners</div>
                          {majorityFields.length < 5 && (
                            <MDBBtn
                              className={`primary`}
                              type="button"
                              onClick={handleOpenAddPopup}
                            >
                              <MDBIcon fas icon="plus" /> Add
                            </MDBBtn>
                          )}
                        </div>

                        <div style={{ paddingLeft: "10px" }}>
                          <MDBTable>
                            <MDBTableHead>
                              <tr>
                                <th scope="col">S.No</th>
                                <th scope="col">Title <span className="text-danger">*</span></th>
                                <th scope="col">First Name <span className="text-danger">*</span></th>
                                <th scope="col">Last Name <span className="text-danger">*</span></th>
                                <th scope="col">Phone Number <span className="text-danger">*</span></th>
                                <th scope="col">Email Address <span className="text-danger">*</span></th>
                                <th scope="col">% of Ownership <span className="text-danger">*</span></th>
                                {majorityFields.length > 1 && <th scope="col">Remove</th>}
                              </tr>
                            </MDBTableHead>
                            <MDBTableBody>
                              {majorityFields.map((item, index) => (
                                <tr className="inputbox-align" key={item.rhfId}>
                                  <td scope="row">{index + 1}</td>
                                  <td>
                                    <MDBInput
                                      type="text"
                                      className="w-100"
                                      maxLength={50}
                                      {...register(`Majority_Owners.${index}.title`, { required: "Title is required" })}
                                    />
                                    {errors?.Majority_Owners?.[index]?.title && (
                                      <p className="text-danger text-small text-wrap-break">{errors.Majority_Owners[index].title.message}</p>
                                    )}
                                  </td>
                                  <td>
                                    <MDBInput
                                      type="text"
                                      className="w-100"
                                      maxLength={30}
                                      {...register(`Majority_Owners.${index}.first_name`, { required: "First Name is required" })}
                                    />
                                    {errors?.Majority_Owners?.[index]?.first_name && (
                                      <p className="text-danger text-small text-wrap-break">{errors.Majority_Owners[index].first_name.message}</p>
                                    )}
                                  </td>
                                  <td>
                                    <MDBInput
                                      type="text"
                                      className="w-100"
                                      maxLength={30}
                                      {...register(`Majority_Owners.${index}.last_name`, { required: "Last Name is required" })}
                                    />
                                    {errors?.Majority_Owners?.[index]?.last_name && (
                                      <p className="text-danger text-small text-wrap-break">{errors.Majority_Owners[index].last_name.message}</p>
                                    )}
                                  </td>
                                  <td>
                                    <MDBInput
                                      type="text"
                                      className="w-100"
                                      maxLength={11}
                                      onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                          event.preventDefault();
                                        }
                                      }}
                                      {...register(`Majority_Owners.${index}.phone_number`, { required: "Phone Number is required" })}
                                    />
                                    {errors?.Majority_Owners?.[index]?.phone_number && (
                                      <p className="text-danger text-small text-wrap-break">{errors.Majority_Owners[index].phone_number.message}</p>
                                    )}
                                  </td>
                                  <td>
                                    <MDBInput
                                      type="text"
                                      className="w-100"
                                      maxLength={50}
                                      {...register(`Majority_Owners.${index}.email_address`, { required: "Email Address is required" })}
                                    />
                                    {errors?.Majority_Owners?.[index]?.email_address && (
                                      <p className="text-danger text-small text-wrap-break">{errors.Majority_Owners[index].email_address.message}</p>
                                    )}
                                  </td>
                                  <td>
                                    <MDBInput
                                      type="text"
                                      className="w-100"
                                      maxLength={6}
                                      {...register(`Majority_Owners.${index}.Percent_Ownership`, { required: "% of Ownership is required" })}
                                    />
                                    {errors?.Majority_Owners?.[index]?.Percent_Ownership && (
                                      <p className="text-danger text-small text-wrap-break">{errors.Majority_Owners[index].Percent_Ownership.message}</p>
                                    )}
                                  </td>
                                  {majorityFields.length > 1 && (
                                    <td>
                                      <div className="d-flex align-items-center ms-2">
                                        <div
                                          className="custom-hover-bg p-1 cursor-pointer"
                                          onClick={() => {
                                            setSelectedRemoveItem(item);
                                            setShowRemovePopup(true);
                                          }}
                                        >
                                          <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
                                        </div>
                                      </div>
                                    </td>
                                  )}
                                </tr>
                              ))}
                            </MDBTableBody>
                          </MDBTable>
                        </div>
                      </section>
                    </>
                  )}

                  {/* ── Section 6: Compliance Administrator ── */}
                  {complianceAdminstrator &&
                    complianceAdminstrator.length > 0 && (
                      <>
                        <div className="routing-border"></div>
                        <section ref={section6} id="section-6">
                          <div className="general-settings">
                            Compliance Administrator
                          </div>
                          <div style={{ paddingLeft: "10px" }} className="pb_10">
                            <MDBTable>
                              <MDBTableHead>
                                <tr>
                                  <th scope="col">Title <span className="text-danger">*</span></th>
                                  <th scope="col">First Name <span className="text-danger">*</span></th>
                                  <th scope="col">Last Name <span className="text-danger">*</span></th>
                                  <th scope="col">Phone Number <span className="text-danger">*</span></th>
                                  <th scope="col">Email Address <span className="text-danger">*</span></th>
                                </tr>
                              </MDBTableHead>
                              <MDBTableBody>
                                <tr className="inputbox-align">
                                  <td>
                                    <MDBInput
                                      type="text"
                                      className="w-100"
                                      maxLength={50}
                                      {...register("Compliance_Administrator.title", { required: "Title is required" })}
                                    />
                                    {errors?.Compliance_Administrator?.title && (
                                      <p className="text-danger text-small text-wrap-break">{errors.Compliance_Administrator.title.message}</p>
                                    )}
                                  </td>
                                  <td>
                                    <MDBInput
                                      type="text"
                                      className="w-100"
                                      maxLength={30}
                                      {...register("Compliance_Administrator.first_name", { required: "First Name is required" })}
                                    />
                                    {errors?.Compliance_Administrator?.first_name && (
                                      <p className="text-danger text-small text-wrap-break">{errors.Compliance_Administrator.first_name.message}</p>
                                    )}
                                  </td>
                                  <td>
                                    <MDBInput
                                      type="text"
                                      className="w-100"
                                      maxLength={30}
                                      {...register("Compliance_Administrator.last_name", { required: "Last Name is required" })}
                                    />
                                    {errors?.Compliance_Administrator?.last_name && (
                                      <p className="text-danger text-small text-wrap-break">{errors.Compliance_Administrator.last_name.message}</p>
                                    )}
                                  </td>
                                  <td>
                                    <MDBInput
                                      type="text"
                                      className="w-100"
                                      maxLength={11}
                                      onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                          event.preventDefault();
                                        }
                                      }}
                                      {...register("Compliance_Administrator.phone_number", { required: "Phone Number is required" })}
                                    />
                                    {errors?.Compliance_Administrator?.phone_number && (
                                      <p className="text-danger text-small text-wrap-break">{errors.Compliance_Administrator.phone_number.message}</p>
                                    )}
                                  </td>
                                  <td>
                                    <MDBInput
                                      type="text"
                                      className="w-100"
                                      maxLength={50}
                                      {...register("Compliance_Administrator.email_address", { required: "Email Address is required" })}
                                    />
                                    {errors?.Compliance_Administrator?.email_address && (
                                      <p className="text-danger text-small text-wrap-break">{errors.Compliance_Administrator.email_address.message}</p>
                                    )}
                                  </td>
                                </tr>
                              </MDBTableBody>
                            </MDBTable>
                          </div>
                        </section>
                      </>
                    )}
                </div>
              </div>
            </MDBCol>
          </MDBRow>

          {isSave && (
            <SaveChanges
              onClose={closeSave}
              onSave={(e) => {
                e.preventDefault();
                handleSubmit(onSubmit)();
              }}
            />
          )}

          {successMessage && (
            <MDBAlert
              open
              className="alert-center"
              color="success"
              autohide
              position="bottom-right"
              delay={10000}
            >
              <i className="fas fa-check-circle me-3"></i>
              <span className="alert-msg">{successMessage}</span>
            </MDBAlert>
          )}
        </div>
      )}

      {showAddPopup && (
        <PopupLoaderNew
          title="Add Majority Owner"
          size="md"
          content={
            <div className="px-1 py-2">
              <MDBRow className="mb-3">
                <MDBCol size="6">
                  <div className="tel-numbers fw-500 mb-1">Title <span className="text-danger">*</span></div>
                  <MDBInput
                    type="text"
                    placeholder="Title"
                    maxLength={50}
                    {...registerAddOwner("title", { required: "Title is required" })}
                  />
                  {addOwnerErrors.title && <p className="text-danger text-small text-wrap-break">{addOwnerErrors.title.message}</p>}
                </MDBCol>
                <MDBCol size="6">
                  <div className="tel-numbers fw-500 mb-1">% of Ownership <span className="text-danger">*</span></div>
                  <MDBInput
                    type="text"
                    placeholder="% of Ownership"
                    maxLength={6}
                    {...registerAddOwner("Percent_Ownership", { required: "% of Ownership is required" })}
                  />
                  {addOwnerErrors.Percent_Ownership && <p className="text-danger text-small text-wrap-break">{addOwnerErrors.Percent_Ownership.message}</p>}
                </MDBCol>
              </MDBRow>
              <MDBRow className="mb-3">
                <MDBCol size="6">
                  <div className="tel-numbers fw-500 mb-1">First Name <span className="text-danger">*</span></div>
                  <MDBInput
                    type="text"
                    placeholder="First Name"
                    maxLength={30}
                    {...registerAddOwner("first_name", { required: "First Name is required" })}
                  />
                  {addOwnerErrors.first_name && <p className="text-danger text-small text-wrap-break">{addOwnerErrors.first_name.message}</p>}
                </MDBCol>
                <MDBCol size="6">
                  <div className="tel-numbers fw-500 mb-1">Last Name <span className="text-danger">*</span></div>
                  <MDBInput
                    type="text"
                    placeholder="Last Name"
                    maxLength={30}
                    {...registerAddOwner("last_name", { required: "Last Name is required" })}
                  />
                  {addOwnerErrors.last_name && <p className="text-danger text-small text-wrap-break">{addOwnerErrors.last_name.message}</p>}
                </MDBCol>
              </MDBRow>
              <MDBRow className="mb-2">
                <MDBCol size="6">
                  <div className="tel-numbers fw-500 mb-1">Phone Number <span className="text-danger">*</span></div>
                  <MDBInput
                    type="text"
                    placeholder="Phone Number"
                    maxLength={11}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    {...registerAddOwner("phone_number", { required: "Phone Number is required" })}
                  />
                  {addOwnerErrors.phone_number && <p className="text-danger text-small text-wrap-break">{addOwnerErrors.phone_number.message}</p>}
                </MDBCol>
                <MDBCol size="6">
                  <div className="tel-numbers fw-500 mb-1">Email Address <span className="text-danger">*</span></div>
                  <MDBInput
                    type="text"
                    placeholder="Email Address"
                    maxLength={50}
                    {...registerAddOwner("email_address", { required: "Email Address is required" })}
                  />
                  {addOwnerErrors.email_address && <p className="text-danger text-small text-wrap-break">{addOwnerErrors.email_address.message}</p>}
                </MDBCol>
              </MDBRow>
            </div>
          }
          onShow={setShowAddPopup}
          onClose={() => setShowAddPopup(false)}
          onSave={handleSubmitAddOwner(handleSaveAddOwner)}
          flag={1}
        />
      )}

      {showRemovePopup && (
        <PopupLoaderNew
          title="Remove Majority Owner"
          content={
            <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3 rounded-3 square border border-2 border-danger">
              <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
              <span>This will remove the Majority Owner and cannot be undone.</span>
            </div>
          }
          onShow={setShowRemovePopup}
          onClose={() => {
            setShowRemovePopup(false);
            setSelectedRemoveItem(null);
          }}
          onSave={handleSaveRemoveOwner}
          flag={4}
        />
      )}

      {showCountryAlert &&
        <PopupLoader
          title="Alert"
          content={
            <>
              <div className="d-flex align-items-start bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning">
                <MDBIcon fas icon="exclamation-triangle" className="me-2 mt-2 pt-1" size="lg" color="warning" />
                <span>
                  {pendingCountryChange?.section === "Physical_Address"
                    ? "Changing the country will clear the Federal Taxpayer ID/Business Number and associated address fields. You'll need to re-enter relevant details based on the selected country. Do you want to continue?"
                    : "Changing the country will clear the associated address fields. You'll need to re-enter the complete address for the new country. Do you want to continue?"
                  }
                </span>
              </div>
              <MDBModalFooter className="pb-0 pe-0 mt-3">
                <MDBBtn color="secondary" onClick={handleCountryAlertCancel}>
                  Cancel
                </MDBBtn>
                <MDBBtn color="primary" onClick={handleCountryAlertOk}>
                  Ok
                </MDBBtn>
              </MDBModalFooter>
            </>
          }
          onShow={setShowCountryAlert}
          onClose={handleCountryAlertCancel}
        />
      }
    </>
  );
}

export default BillingAccInfo;
